import { useMutualFundDetailScrollEvent } from '../../hooks/useMutualFundDetailScrollEvent'
import { MutualFundDetailSections, MutualFundDetailSubSections } from '../../types/mutual-fund-detail.types'
import { renderSubSection } from '../../utils/sectionsConfig'

export const HeaderAccordions = ({
  sectionKey,
  subsections
}: {
  sectionKey: `${MutualFundDetailSections}`
  subsections: `${MutualFundDetailSubSections}`[]
}) => {
  const sectionRef = useMutualFundDetailScrollEvent({ sectionKey })

  return (
    <div ref={sectionRef} className='flex flex-col w-full rounded-b-xl'>
      {subsections?.map((subsection, idx) => {
        return <div key={`${subsection}${idx}`}> {renderSubSection({ componentKey: subsection })} </div>
      })}
    </div>
  )
}
